import { zOrderPhotosSchemaDom, } from "@/types/orderPhotos/orderPhotos.domain";
import { zOrderPhotosSchemaDto, } from "@/types/orderPhotos/orderPhotos.dto";
export const OrderPhotosMapper = {
    toDomain: (dto) => {
        const safeDto = zOrderPhotosSchemaDto.parse(dto);
        return {
            id: safeDto.id,
            imageUrls: safeDto.image_urls,
            orderId: safeDto.order_id,
            timeType: safeDto.time_type,
        };
    },
    toDto: (domain) => {
        const safeDomain = zOrderPhotosSchemaDom.parse(domain);
        return zOrderPhotosSchemaDto.parse({
            id: safeDomain.id,
            image_urls: safeDomain.imageUrls,
            order_id: safeDomain.orderId,
            time_type: safeDomain.timeType,
        });
    },
};
